import React from 'react';
import {Route} from "react-router-dom";
import {ExerciseVideo} from "./ExerciseVideo";

export const PublicRouting = [
  <Route key="exercise-video" path="/exercise-video" element={<ExerciseVideo />} />
]
